export default "__VITE_ASSET__DfPlzGls__"